import { ExtendedNotificationSettings } from '../useUserProfileNotificationSettings';

export const extendedNotificationSettingsInitialValues: ExtendedNotificationSettings = {
  notificationSettingId: '',
  applicationUserId: '',
  providerId: '',
  trainerId: '',
  dailyMailEnabled: false,
  lastDailyMailSent: '',

  receiveLivestreamReminder: false,
  showToastedMessagesForSelfCheckIns: false,

  receiveBookingMailCopy: false,
  bookingMailCopyInterval: null,
  bookingMailCopyIntervalDaily: false,
  bookingMailCopyIntervalImmediately: false,

  receiveCheckoutMailCopy: false,
  checkoutMailCopyInterval: null,
  checkoutMailCopyIntervalDaily: false,
  checkoutMailCopyIntervalImmediately: false,

  receiveCancellationMailCopy: false,
  cancellationMailCopyInterval: null,
  cancellationMailCopyIntervalDaily: false,
  cancellationMailCopyIntervalImmediately: false,
  receiveContractRenewalCancellationEmail: false,
};

export const hasExtendedNotificationSettingsObjectChanged = (
  a: ExtendedNotificationSettings,
  b: ExtendedNotificationSettings,
) =>
  [
    'dailyMailEnabled',
    'lastDailyMailSent',
    'receiveBookingMailCopy',
    'receiveCancellationMailCopy',
    'receiveCheckoutMailCopy',
    'receiveLivestreamReminder',
    'bookingMailCopyInterval',
    'cancellationMailCopyInterval',
    'checkoutMailCopyInterval',
    'receiveContractRenewalCancellationEmail',
  ].some(
    (name) =>
      a[name as keyof ExtendedNotificationSettings] !==
      b[name as keyof ExtendedNotificationSettings],
  );
